import { render } from "./fee.vue?vue&type=template&id=b04f3516&scoped=true"
import script from "./fee.vue?vue&type=script&lang=js"
export * from "./fee.vue?vue&type=script&lang=js"

import "./fee.vue?vue&type=style&index=0&id=b04f3516&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b04f3516"]])

export default __exports__